// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-total[data-v-f064f7e0]{display:flex}.comment-total .text[data-v-f064f7e0]{margin:10px}.comment-total .input[data-v-f064f7e0]{margin:5px}.comment-total .total[data-v-f064f7e0]{margin-left:85%}", ""]);
// Exports
module.exports = exports;
